import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from "axios"; import { handleAuthError, newFormatDate } from "../../utils";
import { Badge, Col, Container, Form, Input, Label, Modal, ModalBody, ModalHeader, Row, } from "reactstrap";
import withAuth from "../withAuth";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseUrl } from '../../Network';
import 'moment-timezone';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Copy, ExternalLink } from "lucide-react";
import { usePagination } from "../../hooks/usePagination";
import PaginationControls from "../../components/Common/PaginationControls";
import { useConfirm } from "../../contexts/ConfirmContext";


const ManageProgram = () => {
    document.title = "Manage Project | RYD Admin";
    const { showConfirm } = useConfirm();

    const [programs, setPrograms] = useState([]);
    const [programsList, setProgramsList] = useState([]);
    const [modal, setModal] = useState(false);
    const [teachers, setTeachers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [multiIDs, setMultiIDs] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [coupons, setCoupons] = useState([]);
    const [cohorts, setCohorts] = useState([]);
    const [packages, setPackages] = useState([]);
    const [filteredProgramList0, setFilteredProgramList0] = useState([]);
    const [filteredProgramList2, setFilteredProgramList2] = useState([]);
    const [displayProgramList, setDisplayProgramList] = useState([]);

    const {
        paginatedData: paginatedPrograms,
        currentPage,
        totalPages,
        totalItems,
        pageSize,
        showAll,
        handlePageChange,
        handlePageSizeChange,
        goToNextPage,
        goToPreviousPage,
        canPreviousPage,
        canNextPage,
        paginatedDataLength,
    } = usePagination(displayProgramList, 20);

    useEffect(() => {
        fetchPrograms().then(r => null);
    }, [modal]);



    useEffect(() => {
        fetchPrograms().then(r => null)
    }, [modal]);

    useEffect(() => {
        fetchTeachers().then(r => null)
        //fetch coupon
        fetchCoupons().then(r => null)
    }, []);

    const fetchCoupons = async () => {
        try {
            const response = await axios.get(`${baseUrl}/admin/coupon/all`, { params: { limit: 10000 } });
            const responseData = response.data.data;
            const data = Array.isArray(responseData) ? responseData : (responseData?.data || []);
            setCoupons(Array.isArray(data) ? data : []);
        } catch (error) {
            handleAuthError(error)
            console.error("Error:", error);
        }
    };

    function compareFn(a, b) {
        if (a.time < b.time && a.day < b.day) {
            return -1;
        } else if (a.time > b.time && a.day > b.day) {
            return 1;
        }
        // a must be equal to b
        return 0;
    }

    const fetchPrograms = async () => {
        try {
            const packages = await axios.get(`${baseUrl}/admin/package/all`, { params: { limit: 10000 } });
            const cohorts = await axios.get(`${baseUrl}/admin/cohort/all`, { params: { limit: 10000 } });
            const response = await axios.get(`${baseUrl}/admin/program/active/all`);
            
            const packagesData = packages.data.data;
            const packagesArray = Array.isArray(packagesData) ? packagesData : (packagesData?.data || []);
            
            const cohortsData = cohorts.data.data;
            const cohortsArray = Array.isArray(cohortsData) ? cohortsData : (cohortsData?.data || []);
            
            setPrograms(response?.data?.data);
            setCohorts(Array.isArray(cohortsArray) ? cohortsArray : []);
            setPackages(Array.isArray(packagesArray) ? packagesArray : [])
            setLoading(false);
            setTimeout(() => {
                //filter to it
                const responseData = response?.data?.data;
                const xdata = Array.isArray(responseData) ? responseData : (responseData?.data || []);
                //setProgramsList(xdata.sort(compareFn))
                const __xdata = Array.isArray(xdata) ? xdata.sort(compareFn) : []
                setProgramsList(__xdata)
                setDisplayProgramList(__xdata)
                setFilteredProgramList0(__xdata)
                setFilteredProgramList2(__xdata)
                setLoading(false); // Update loading state after data fetch
            }, 100)
        } catch (error) {
            handleAuthError(error)
            setLoading(false);
            //console.error("Error:", error);
        }
    };

    const fetchTeachers = async () => {
        try {
            const response = await axios.get(`${baseUrl}/admin/teacher/all`);
            setTeachers(response.data.data);
        } catch (error) {
            handleAuthError(error)
            console.error("Error:", error);
        }
    };

    const exportToExcel = () => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';

        const dataToExport = displayProgramList.map(program => ({
            'Parent Name': `${program?.child?.parent?.firstName} ${program?.child?.parent?.lastName}`,
            'Child Name': `${program?.child?.firstName} ${program?.child?.lastName}`,
            'Project-url': program?.projectUrl,
        }));

        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        saveAs(data, `programs_export_${new Date().getTime()}` + fileExtension);
    };

    const handleSelectAllChange = (e) => {
        if (e.target.checked) {
            // Select all items
            const allIDs = displayProgramList.map(program => program.id);
            setMultiIDs(allIDs);
            toast.warn("All items have been added to the action list.");
        } else {
            setMultiIDs([])
            toast.error("All items have been removed from the action list.");
        }
    };

    return (
        <React.Fragment>
            <ToastContainer />
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Dashboard" breadcrumbItem={`Manage Project (${displayProgramList.length})`} />
                    <Row>
                        <Col lg="12">
                            <Col md={12}>
                                <div className="d-flex flex-wrap align-items-center gap-2 mb-3">

                                    {/* Clear All Filters Button */}
                                    <div>
                                        <button
                                            className="btn btn-secondary"
                                            onClick={() => {
                                                setSearchQuery('');
                                                setDisplayProgramList(programs);
                                                setFilteredProgramList0(programs);
                                                setFilteredProgramList2(programs);
                                                // Reset all select elements to their default values
                                                document.querySelectorAll('.filter-control').forEach(select => {
                                                    select.value = 0;
                                                });
                                            }}
                                        >
                                            Clear All Filters
                                        </button>
                                    </div>

                                    {/* Search Input */}
                                    <div>
                                        <Input
                                            type="text"
                                            placeholder="Search"
                                            value={searchQuery}
                                            onChange={(e) => {
                                                setSearchQuery(e.target.value);
                                                // Function to filter package list based on search query
                                                const searchProgrammed = programs.filter((program) =>
                                                    `${program?.child?.firstName} ${program?.child?.lastName} ${program?.child?.parent?.firstName} ${program?.child?.parent?.lastName}`
                                                        .toLowerCase()
                                                        .includes(e.target.value.toLowerCase())
                                                );
                                                setDisplayProgramList(searchProgrammed);
                                                setFilteredProgramList0(searchProgrammed);
                                                setFilteredProgramList2(searchProgrammed);
                                            }}
                                        />
                                    </div>

                                    {/* Cohort Filter */}
                                    <div>
                                        <select
                                            className="form-control filter-control"
                                            onChange={(e) => {
                                                const cohortId = Number(e.target.value);
                                                const filtered = cohortId === 0
                                                    ? programs
                                                    : programs.filter(r => Number(r.cohortId) === cohortId);

                                                setDisplayProgramList(filtered);
                                                setFilteredProgramList0(filtered);
                                                setFilteredProgramList2(filtered);
                                            }}
                                        >
                                            <option value={0}>All Cohorts</option>
                                            {cohorts && cohorts.map((d, i) =>
                                                <option key={i} value={d.id}>{d.title}</option>
                                            )}
                                        </select>
                                    </div>

                                    {/* Package Filter */}
                                    <div>
                                        <select
                                            style={{ width: 150 }}
                                            className="form-control filter-control"
                                            onChange={(e) => {
                                                const packageID = Number(e.target.value);
                                                const filtered = packageID === 0
                                                    ? filteredProgramList2
                                                    : filteredProgramList2.filter((p) => p?.package?.id === packageID);

                                                setDisplayProgramList(filtered);
                                            }}
                                        >
                                            <option value={0}>All Packages</option>
                                            {packages.map((p, i) =>
                                                <option key={i} value={p.id}>{p.title}</option>
                                            )}
                                        </select>
                                    </div>
                                    {/* Teacher Assignment Filter */}
                                    <div>
                                        <select
                                            className="form-control filter-control"
                                            onChange={(e) => {
                                                const value = Number(e.target.value);
                                                let filtered = filteredProgramList2;

                                                if (value === 1) {
                                                    filtered = filteredProgramList2.filter(r => r.teacherId !== null);
                                                } else if (value === 2) {
                                                    filtered = filteredProgramList2.filter(r => r.teacherId === null);
                                                }

                                                setDisplayProgramList(filtered);
                                            }}
                                        >
                                            <option value={0}>All Filter(s)</option>
                                            <option value={1}>With Teacher</option>
                                            <option value={2}>With No Teacher</option>
                                        </select>
                                    </div>

                                    {/* Specific Teacher Filter */}
                                    <div>
                                        <select
                                            className="form-control filter-control"
                                            onChange={(e) => {
                                                const teacherId = Number(e.target.value);
                                                const filtered = teacherId === 0
                                                    ? filteredProgramList2
                                                    : filteredProgramList2.filter(r => r.teacherId === teacherId);

                                                setDisplayProgramList(filtered);
                                            }}
                                        >
                                            <option value={0}>Filter by Teacher(s)</option>
                                            {teachers?.length > 0 &&
                                                teachers?.map((teacher) => (
                                                    <option key={teacher?.id} value={teacher?.id}>
                                                        {teacher.firstName} {teacher.lastName}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                    <button
                                        onClick={() => {
                                            showConfirm({ title: "Export data", message: "You're about to export the programs data. Do you want to proceed?", variant: "primary" }).then((ok) => { if (ok) exportToExcel(); });
                                        }}
                                        title="Export to Excel"
                                    >
                                        <i className="mdi mdi-file-excel font-size-20"></i>
                                    </button>
                                </div>
                            </Col>
                            {/* </Row> */}
                            <Row>
                                <Col xl="12" style={{ overflow: 'scroll', width: '98%' }}>
                                    {loading ? (
                                        <div className="text-center mt-5">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    ) : displayProgramList.length === 0 ? (
                                        <div className="text-center mt-5">
                                            <h3>No data available</h3>
                                        </div>
                                    ) : (
                                        <table className="table align-middle table-hover">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        <div style={{ width: 50 }} className={'align-middle'}>
                                                            <input
                                                                style={{ marginRight: 5 }}
                                                                type={'checkbox'}
                                                                onChange={e => handleSelectAllChange(e)}
                                                            />
                                                            All
                                                        </div>
                                                    </th>
                                                    <th>P.Name</th>
                                                    <th>P.Assigned.To</th>
                                                    <th>C.Name</th>
                                                    <th>T.Name</th>
                                                    <th>P.Title</th>
                                                    <th>Project</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {paginatedPrograms.map((program, index) => {
                                                    const globalIndex = showAll 
                                                        ? index 
                                                        : (currentPage - 1) * pageSize + index;
                                                    return (
                                                        <tr key={program.id || index}
                                                            style={{ backgroundColor: (program.isPaid) ? '#f1fdf4' : '#fff' }}>
                                                            <td>
                                                                <div style={{ width: 50 }} className={'align-middle'}>
                                                                    <input style={{ marginRight: 5 }} type={'checkbox'} checked={multiIDs.includes(program.id)}
                                                                        onClick={(d) => {
                                                                            //multiple selection push to array
                                                                            if (multiIDs.includes(program.id)) {
                                                                                //remove from array
                                                                                setMultiIDs(multiIDs.filter(i => i !== program.id))
                                                                                toast.error(program?.child?.firstName + " removed is been from the action list.")
                                                                            } else {
                                                                                setMultiIDs([...multiIDs, program.id])
                                                                                toast.warn(program?.child?.firstName + " has been added to action list.")
                                                                            }
                                                                        }} />
                                                                    {globalIndex + 1}
                                                                </div>
                                                            </td>
                                                        <td>{program?.child?.parent?.firstName + " " + program?.child?.parent?.lastName}</td>
                                                        <td>{program?.child?.parent?.assignedTo ? program?.child?.parent?.admin?.fullName : "Unassigned"}</td>
                                                        <td>{program?.child?.firstName + " " + program?.child?.lastName}
                                                            <br />
                                                            [{program?.child?.parent?.country}]
                                                        </td>
                                                        <td>{program?.teacher?.firstName}</td>
                                                        <td>{program?.package?.title}<br /><small
                                                            style={{ color: 'red' }}>[{program?.cohort?.title || "No Cohort"}]</small>
                                                        </td>
                                                        <td>
                                                            {program?.projectUrl ? (
                                                                <>
                                                                    <Badge color="success">Done</Badge>
                                                                    <span
                                                                        onClick={() => {
                                                                            navigator.clipboard.writeText(program?.projectUrl);
                                                                            toast.success("Copied successfully");
                                                                        }}
                                                                        className="p-1 hover:bg-gray-100 rounded cursor-pointer"
                                                                        title="Copy URL"
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        <Copy size={15} />
                                                                    </span>
                                                                    <span
                                                                        onClick={() => window.open(program?.projectUrl, '_blank')}
                                                                        className="p-1 hover:bg-gray-100 rounded cursor-pointer ml-1"
                                                                        title="Open in new tab"
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        <ExternalLink size={15} />
                                                                    </span>
                                                                </>
                                                            ) : (
                                                                <Badge color="warning">Not yet</Badge>
                                                            )}
                                                        </td>
                                                        <td className="" >
                                                        </td>
                                                    </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    )}
                                    {displayProgramList.length > 0 && (
                                        <PaginationControls
                                            currentPage={currentPage}
                                            totalPages={totalPages}
                                            totalItems={totalItems}
                                            pageSize={pageSize}
                                            showAll={showAll}
                                            handlePageChange={handlePageChange}
                                            handlePageSizeChange={handlePageSizeChange}
                                            goToNextPage={goToNextPage}
                                            goToPreviousPage={goToPreviousPage}
                                            canPreviousPage={canPreviousPage}
                                            canNextPage={canNextPage}
                                            paginatedDataLength={paginatedDataLength}
                                        />
                                    )}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withAuth(ManageProgram);
